import { Message } from "../../../domain/model/Auth";
import { CategoryUnlockCode } from "../../../domain/model/Category";
import { Game, GameRequestModel } from "../../../domain/model/Game";
import {
  Player,
  PlayerStatPerCategoryModel,
  SubcategoriesToResetDataModel,
} from "../../../domain/model/User";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { PlayerRepository } from "./PlayerRepository";

export class PlayerRepositoryImpl implements PlayerRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getCurrentUserInfo(): Promise<Response<Player>> {
    return this.apiService.getCurrentUserInfo();
  }
  updatePlayer(player: Player): Promise<Response<Message>> {
    return this.apiService.updatePlayer(player);
  }
  addToQuestionsHistory(questionId: string): Promise<Response<Message>> {
    return this.apiService.addToQuestionsHistory(questionId);
  }
  addToGames(model: GameRequestModel): Promise<Response<Game>> {
    return this.apiService.addToGames(model);
  }
  gameStarted(): Promise<Response<Message>> {
    return this.apiService.gameStarted();
  }
  resetQuestions(
    model: SubcategoriesToResetDataModel
  ): Promise<Response<Message>> {
    return this.apiService.resetQuestions(model);
  }
  addToUnfinishedGames(gameDataJson: string): Promise<Response<Message>> {
    return this.apiService.addToUnfinishedGames(gameDataJson);
  }
  removeFromUnfinishedGames(index: number): Promise<Response<Message>> {
    return this.apiService.removeFromUnfinishedGames(index);
  }
  deleteAccount(playerId: string): Promise<Response<Message>> {
    return this.apiService.deleteAccount(playerId);
  }
  getPlayerCategoriesStats(
    id: string
  ): Promise<Response<Array<PlayerStatPerCategoryModel>>> {
    return this.apiService.getPlayerCategoriesStats(id);
  }
  getCurrentUserGames(): Promise<Response<Array<Game>>> {
    return this.apiService.getCurrentUserGames();
  }
  getCurrentUserReferralUnlockedCodes(): Promise<
    Response<Array<CategoryUnlockCode>>
  > {
    return this.apiService.getCurrentUserReferralUnlockedCodes();
  }
}
